module.exports = {"name":"Najbližšie stretnutia","icon":"<i class='material-icons'>fitness_center</i>","widget":[{"type":"competition-matches","schemas":{},"initData":{},"paths":{"image":{"src":"match.baseData.homeClub.refData.logoInfo.logo","type":"club"}}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/matches/matches.json
// module id = 364
// module chunks = 0